import { initConditionalLogic } from './conditional-logic'
import { initStepNavigation } from './navigation'
import { initPhoneMasks } from './phone-mask'
import { renderReviewSummary } from './review-summary'
import { initSubmit } from './submit'
import { ensureTurnstileRendered } from './turnstile'
import { initValidation, validateStep } from './validation'
import { initVehicleCascade } from './vehicle-cascade'
import { initVinLookup } from './vin-lookup'

const REVIEW_STEP = 3

export function initForm(): void {
  const form = document.getElementById('donationForm') as HTMLFormElement | null
  if (!form) throw new Error('#donationForm missing')

  initConditionalLogic()
  initPhoneMasks(form)
  const cascade = initVehicleCascade()
  initVinLookup(form, cascade)
  initValidation(form)

  const nav = initStepNavigation({
    form,
    onValidateStep: (stepIndex) => validateStep(form, stepIndex),
    onStepChange: (stepIndex) => {
      if (stepIndex === REVIEW_STEP) {
        renderReviewSummary(form, (step) => nav.goToForEdit(step))
        ensureTurnstileRendered()
      }
    },
  })

  initSubmit(form)
}
